// Optimized scroll helper to prevent forced reflows
let rafId: number | null = null

export function smoothScrollToElement(elementId: string) {
  // Cancel any pending scroll
  if (rafId !== null) {
    cancelAnimationFrame(rafId)
  }

  // Use double RAF for better performance
  rafId = requestAnimationFrame(() => {
    rafId = requestAnimationFrame(() => {
      const el = document.getElementById(elementId)
      if (!el) return

      // Batch DOM reads
      const rect = el.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const targetPosition = rect.top + scrollTop

      // Perform scroll in next frame
      requestAnimationFrame(() => {
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth',
        })
      })
    })
  })
}
